<box>
  <box-icon src="assets/svg/ressources/green-salad.svg"></box-icon>

  <box-number>2</box-number>

  <box-footer> Composez votre crédit </box-footer>
</box>
